import { DashboardFiltersPayload } from '../../services/dashboard.service';
import { ATTENTION_METRIC_NAME, BrandColors } from '../../shared/types/common';
import { DateRangeValue } from '../../utils/time';
import { ClickRisk, InventoryQualityTableRow } from '../my-brand-screen/types';

export interface CampaignOverviewRequest extends DashboardFiltersPayload {
  //TODO - Remove optional on API integration
  accountKeys?: string[];
  campaignIds: string[];
  creativeIds: string[];
}

export interface CampaignOverviewResponse {
  impressions: number;
  ctr: number;
  viewability: number;
  attention: number;
  timeInView: number;
  clutter: number;
  clickRisk: ClickRisk;
  attentionTrend: number;
  timeInViewTrend: number;
  clutterTrend: number;
}

export type SortFieldType = 'domain' | 'category' | 'impressions' | 'ctr' | 'viewability' | 'attention' | 'refreshInterval' | 'density' | 'cpm'

export interface InventoryQualityRequest extends CampaignOverviewRequest, DateRangeValue {
  categories: string[];
  sortField?: SortFieldType;
  limit?: number;
  offset?: number;
  isAsc?: boolean;
  date?: boolean;
}

export interface InventoryQualitySite {
  domain: string;
  category: string;
  impressions: number;
  ctr: number;
  viewability: number;
  attention: number;
  refreshInterval: number;
  density: number;
  clickRisk: ClickRisk;
  cpm: number;
}

export interface InventoryQualityResponse {
  sites: InventoryQualityTableRow[];
  total: number;
}

export interface InventoryQualityCsvResponse {
  fileUrl: string;
}

export interface ContentCategoryBreakdownRequest extends CampaignOverviewRequest {
  metric?:string;
  limit?: number;
}

export interface ContentCategoryBreakdownResponse {
  categories: { name: string; share: number }[];
  campaignShare: number;
}

export interface SitesPerformanceRequest extends CampaignOverviewRequest {
  limit?: number;
}

export interface SitesPerformanceResponse {
  sites: string[];
}

export interface RefreshRateDistributionRequest extends CampaignOverviewRequest {
  limit?: number;
}

export interface RefreshRateBucket {
  [bucket: string]: number;
}

export interface RefreshRateDistributionSite {
  domain: string;
  refreshRateBuckets: RefreshRateBucket;
}

export interface RefreshRateDistributionResponse {
  sites: RefreshRateDistributionSite[];
}

export interface CampaignFiltersRequest extends DateRangeValue {
  accountKeys: string[];
}

export interface CampaignFiltersResponse {
  [account: string]: CampaignFilters
}

export interface CampaignFilters {
  campaigns: {
    id: string;
    // false = no data for the selected dates and filters
    hasData?: boolean;
    creatives: {
      id: string;
      categories: string[];
    }[];
  }[];
}

export type CampaignDataFetchResult = {
  overview?: CampaignOverviewResponse;
  breakdownValue?: ContentCategoryBreakdownResponse;
  lowestSites?: SitesPerformanceResponse;
  refreshRateDistribution?: RefreshRateDistributionResponse;
  inventoryQuality?: InventoryQualityResponse;
}

export type SelectedFilters = {
  campaignIds: string[];
  creativeIds: string[];
  categories: string[];
};

export function isSelectedFilters(filters: any): filters is SelectedFilters {
  return (
    filters &&
    filters.campaignIds &&
    Array.isArray(filters.campaignIds) &&
    filters.creativeIds &&
    Array.isArray(filters.creativeIds) &&
    filters.categories &&
    Array.isArray(filters.categories)
  )
}
export const BREAKDOWN_COMPARISON_TITLE = "Campaign's Average"


export const SHARE_OF_VOICE_WIDGET_TITLE = 'Share of Voice';

export enum CsvOption {
  SUMMARY = 'Download summary view (.csv)',
  DAILY_BREAKDOWN = 'Download daily breakdown (EST time zone, .csv)'
}

export const DOWNLOAD_CSV_OPTIONS = [
  CsvOption.SUMMARY,
  CsvOption.DAILY_BREAKDOWN
]

const validSortFields: SortFieldType[] = [
  'domain',
  'category',
  'impressions',
  'ctr',
  'viewability',
  'attention',
  'refreshInterval',
  'density',
  'cpm',
];

export function isSortField(value: string): value is SortFieldType {
  return validSortFields.includes(value as SortFieldType);
}
